<script lang="ts">
	import CkEditorContent from "@components/common/CkEditorContent.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const id = $props.id();
	const { data, lightboxId = id }: ContentBlockComponentProps<ContentType.CKEditor> = $props();
</script>

<CkEditorContent html={data.html} {lightboxId} />
